import { BaseTimeSlotModel as o } from "./baseTimeSlot.model.js";
class r extends o {
  constructor(e) {
    super(e), this.closed = e.closed, this.services = e.services;
  }
  inFullRange(e, s) {
    return super.inFullRange(e) && !this.closed && s.some((l) => this.services.includes(l));
  }
}
export {
  r as SpecialHoursPerServiceSlotModel
};
//# sourceMappingURL=specialHoursPerServiceSlot.model.js.map
